const without = (arr, item) =>
  Array.isArray(item)
    ? arr.filter(_item => !item.includes(_item))
    : arr.filter(_item => _item !== item);

export default without;
